<template>
  <Modal v-model="printComplianceLabelsModal" :title="$t('key1000323')" width="800"
    :transfer="false" class-name="commonModalStyles" :mask-closable="false">
    <div class="table_box mt20">
      <Table
        highlight-row
        border
        max-height="560"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
        <template #printQuantity="{row, index}">
          <InputNumber
            :placeholder="$t('key1000324')"
            :max="9999999"
            :min="1"
            style="width: 120px"
            :formatter="value => `${parseInt(value)}`"
            v-model.trim="tableData[index].printQuantity">
          </InputNumber>
        </template>
      </Table>
    </div>
    <template #footer>
      <Button class="mr15" type="primary" @click="printComplianceLabelsModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {setLinkPath} from "@/utils/common";

export default {
  name: 'printComplianceLabelsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      printComplianceLabelsModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let ymsSku = params.row.ymsSku;
            return h('span', {class: 'themeColor'}, ymsSku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000317'),
          key: 'quantity',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000318'),
          key: 'printQuantity',
          align: 'center',
          minWidth: 150,
          slot: 'printQuantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 100,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320'),
                    show: true,
                    clickFn: () => {
                      v.printComplianceLabelsBtn(params.row, params.index);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
    };
  },
  methods: {
    // 初始化数据
    initPrintComplianceLabelsData(details) {
      this.tableData = [];
      let ymsPackageGoods = [];
      // 判断是否是速卖通全托管订单
      if (details.orderType === 'ONE_STOP_SERVICE' && details.carrierCode === 'aliexpressChoice') {
        ymsPackageGoods = details.ymsPackageGoods || [];
        ymsPackageGoods.map((item) => {
          if (details.platformProductLabelPath) {
            item.productLabelPath = setLinkPath(details.platformProductLabelPath); // 速卖通全托管的合规标签是在订单级别
          }
        });
      } else {
        ymsPackageGoods = details.ymsPackageGoods || [];
      }
      if (ymsPackageGoods.length > 0) {
        ymsPackageGoods.map((item) => {
          item.printQuantity = null;
        });
      }
      this.tableData = JSON.parse(JSON.stringify(ymsPackageGoods));
      this.printComplianceLabelsModal = true;
    },
    // 打印
    printComplianceLabelsBtn(obj, currentIndex) {
      let printQuantity = this.tableData[currentIndex].printQuantity;
      if (printQuantity <= 0) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000321'));
        return false;
      }
      let productLabelPath = obj.productLabelPath;
      if (productLabelPath) {
        let query = {
          quantity: printQuantity,
          url: productLabelPath
        };
        this.axios.post(api.post_ymsCommonUtil_mergePdf, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let labelPath = response.data.datas;
            if (labelPath) {
              this.commonPrint(labelPath, obj.ymsSku);
              this.printComplianceLabelsModal = false;
            }
          }
        });
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000322'));
        return false;
      }
    }
  }
};
</script>

<style lang="less">

</style>
